import { EditorOperatorEnum } from '@/state/editor-store';
import { GeneratorTypeEnums } from '@/state/generator-store';
import { isEmpty } from 'lodash-es';
import { useState, useEffect } from 'react';

const EditorCreditsMap = {
  [EditorOperatorEnum.INTRO]: 1,
  [EditorOperatorEnum.TRIM]: 0,
  [EditorOperatorEnum.REFILL]: 1,
  [EditorOperatorEnum.EXTEND]: 1,
  [EditorOperatorEnum.FADE_OUT]: 0,
  [EditorOperatorEnum.OUTRO]: 1,
  [EditorOperatorEnum.NONE]: 0,
};

interface UseCreditProps {
  duration: number;
  operator?: EditorOperatorEnum;
  editorDuration: number;
  isGeneratorDrawerShow: boolean;
  generatorType: GeneratorTypeEnums;
  tracksCount: number;
}

const creditSpending = (duration: number, tracksCount: number) => {
  return Math.ceil(duration / 60) * tracksCount;
};

// Custom hook for credit calculation
export const useCredit = ({ duration, operator, editorDuration, isGeneratorDrawerShow, generatorType, tracksCount }: UseCreditProps) => {
  const [credit, setCredit] = useState(1);

  useEffect(() => {
    if (generatorType === GeneratorTypeEnums.EDITOR && !isEmpty(operator)) {
      if (operator === EditorOperatorEnum.EXTEND) {
        return setCredit(creditSpending(editorDuration, tracksCount));
      }
      return setCredit(EditorCreditsMap[operator as EditorOperatorEnum] * tracksCount);
    }
    return setCredit(creditSpending(duration, tracksCount));
  }, [duration, operator, editorDuration, isGeneratorDrawerShow, tracksCount]);

  return credit;
};
